/**
 * Shared Safari Club logo for all jsPDF exports (same Cloudinary asset everywhere).
 */
export const PDF_BRAND_LOGO_URL =
  'https://res.cloudinary.com/du5efpres/image/upload/q_auto/f_auto/v1775821393/safari-club-no-background_vowlyw.png';

function logoUrlForPdfFetch() {
  return PDF_BRAND_LOGO_URL.includes('/f_auto/')
    ? PDF_BRAND_LOGO_URL.replace('/f_auto/', '/f_png/')
    : PDF_BRAND_LOGO_URL;
}

export function pdfDataUrlImageFormat(dataUrl) {
  if (typeof dataUrl !== 'string') return 'PNG';
  if (dataUrl.startsWith('data:image/png')) return 'PNG';
  if (dataUrl.startsWith('data:image/jpeg') || dataUrl.startsWith('data:image/jpg')) return 'JPEG';
  if (dataUrl.startsWith('data:image/webp')) return 'WEBP';
  return 'PNG';
}

export async function fetchPdfBrandLogoDataUrl() {
  try {
    const res = await fetch(logoUrlForPdfFetch(), { mode: 'cors' });
    if (!res.ok) throw new Error('fetch failed');
    const blob = await res.blob();
    return await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  } catch {
    return null;
  }
}

/**
 * Draw the brand logo on a jsPDF document (top). Returns Y to continue body text below.
 *
 * @param {import('jspdf').jsPDF} doc
 * @param {{ maxWidthMm?: number, startY?: number, align?: 'center' | 'left', leftMargin?: number, gapAfterMm?: number }} [options]
 * @returns {Promise<{ nextY: number; added: boolean }>}
 */
export async function addPdfBrandLogo(doc, options = {}) {
  const {
    maxWidthMm = 40,
    startY = 10,
    align = 'center',
    leftMargin = 14,
    gapAfterMm = 4
  } = options;

  const pageW = doc.internal.pageSize.getWidth();
  const dataUrl = await fetchPdfBrandLogoDataUrl();
  if (!dataUrl) {
    return { nextY: startY, added: false };
  }
  try {
    const fmt = pdfDataUrlImageFormat(dataUrl);
    const props = doc.getImageProperties(dataUrl);
    const w = maxWidthMm;
    const h = (props.height * w) / props.width;
    const x = align === 'center' ? (pageW - w) / 2 : leftMargin;
    doc.addImage(dataUrl, fmt, x, startY, w, h);
    return { nextY: startY + h + gapAfterMm, added: true };
  } catch {
    return { nextY: startY, added: false };
  }
}
